import * as React from 'react';
import { MyHomeListingContainer as DesktopContainer } from '../MyHomeListingContainer/Desktop';
import { MyHomeListingContainer as MobileContainer } from '../MyHomeListingContainer/Mobile';
import { HeroBanner } from '../../components/HeroBanner';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { trackGoBackClick } from './tracking';
import { useSelector } from 'react-redux';
import { selectMyHomeId } from '../../selectors/selectMyHomeId';

export const HeroContainer: React.FC = () => {
  const myHomeId = useSelector(selectMyHomeId);
  const goToMyHomeLink = myHomeId ? `/my-home/?myHomeId=${myHomeId}` : '/my-home';

  const isDesktop = useIsDesktop();
  const ListingComponent = isDesktop ? DesktopContainer : MobileContainer;

  const handleBackClick = React.useCallback(() => {
    trackGoBackClick();

    window.location.href = goToMyHomeLink;
  }, []);

  return (
    <HeroBanner isDesktop={isDesktop} onBackClick={handleBackClick}>
      <ListingComponent />
    </HeroBanner>
  );
};
